<template>
    <section class="pre-footer__container">
        <template v-for="(section) in sections" :key="section.title">
            <section v-if="(isDesktop && !section.showOnMobile) || (!isDesktop && section.showOnMobile)" class="pre-footer__container__section">
                <span class="pre-footer__container__section__title">
                    {{ section.title }}
                </span>
                <transition name="slide-fade">
                    <ul class="pre-footer__container__section__list-content"
                        v-if="show == section.title || isDesktop">
                        <li v-for="url in section.urls"
                            :key="url.url"
                            class="pre-footer__container__section__list-content__item">
                            <a :href="url.url" rel="dofollow"
                            class="pre-footer__container__section__list-item__link" target="_blank">{{ url.name }}</a>
                        </li>
                    </ul>
                </transition>
            </section>
        </template>
    </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
    setup() {

        const show = ref('');
        const isDesktop = ref(window.innerWidth >= 768);

        function updateScreenSize() {
            isDesktop.value = window.innerWidth >= 768;
        }

        function expand_menu(url) {
            if (url === show.value) {
                show.value = '';
            } else {
                show.value = url;
            }
        }

        onMounted(() => {
            window.addEventListener('resize', updateScreenSize)
        })

        onUnmounted(() => {
            window.removeEventListener('resize', updateScreenSize)
        })

        const sections = [
        {
            title: '',
            urls: [
            {
                url: "https://ibancar.com/como-funciona",
                name: "¿Cómo funciona?",
            },
            {
                url: "https://ibancar.com/quienes-somos",
                name: "¿Quiénes somos?"
            },
            {
                url: "https://ibancar.com/credito-coche",
                name: "Ventajas"
            },
            {
                url: "https://www.blogibancar.com/",
                name: "Blog"
            },
            ]
        },
        {
            title: '',
            urls: [
            {
                url: "https://ibancar.com/como-funciona",
                name: "Preguntas frecuentes"
            },
            {
                url: "https://ibancar.com/credito-coche/#packServicios",
                name: "Préstamo por tu coche"
            },
            {
                url: "https://ibancar.com/credito-coche",
                name: "Empeño de coche"
            },
            {
                url: "https://ibancar.com/credito-coche",
                name: "Dinero por tu coche"
            }
            ]
        },
        {
            title: '',
            urls: [
            {
                url: "https://ibancar.com/politica-privacidad",
                name: "Política de privacidad"
            },
            {
                url: "https://ibancar.com/politica-cookies",
                name: "Política de cookies"
            },
            {
                url: "https://ibancar.com/aviso-legal",
                name: "Aviso legal"
            },
            {
                url: "https://ibancar.com/sitemap.xml",
                name: "Site map"
            }
            ]
        },
        {
            title: '',
            urls: [
            {
                url: "https://p2p.ibancar.com/",
                name: "Ibancar P2P "
            },
            {
                url: "https://p2p.ibancar.com/",
                name: "transparency site"
            },
            {
                url: "https://ibancar.com/grupper-platform",
                name: "Information for Grupeer Investors"
            }
            ]
        },
        {
            title: '',
            showOnMobile: true,
            urls: [
            { url: "https://ibancar.com/como-funciona", name: "Preguntas frecuentes" },
            { url: "https://ibancar.com/credito-coche/#packServicios", name: "Préstamo por tu coche" },
            { url: "https://ibancar.com/credito-coche", name: "Empeño de coche" },
            { url: "https://ibancar.com/credito-coche", name: "Dinero por tu coche" },
            ]
        },
        {
            title: '',
            showOnMobile: true,
            urls: [
            { url: "https://ibancar.com/politica-privacidad", name: "Política de privacidad" },
            { url: "https://ibancar.com/politica-cookies", name: "Política de cookies" },
            { url: "https://ibancar.com/aviso-legal", name: "Aviso legal" },
            { url: "https://ibancar.com/sitemap.xml", name: "Site map" }
            ]
        }
        ];

        return { sections, show, expand_menu, isDesktop }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';

.pre-footer__container {
    color: white;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;

    &__section {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        &__title {
            text-transform: uppercase;
            font-weight: bolder;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                font-size: 30px;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        &__list-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            list-style: none;
            gap: 1rem;
            padding: 0;

            &__item {
                a {
                    list-style: none;
                    color: white;
                    font-size: 14px;
                }
            }
        }
    }
}

.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}

@include media-breakpoint-up(md) {
    .pre-footer__container {
        flex-direction: row;
        gap: 0.5rem;
        justify-content: space-around;

        &__section {
            &__title {
                span {
                    display: none;
                }
            }
            
        }
    }
}
@include media-breakpoint-down(sm) {
 .pre-footer__container {
    color: white;
    margin-bottom: 2rem;
    display: flex; 
    flex-direction: row;
    column-gap: 9rem;

   &__list-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            list-style: none;
            gap: 5rem;
            padding: 0;

            &__item {
                a {
                    list-style: none;
                    color: white;
                    font-size: 14px;
                }
            }
        }
}
}
</style>